import { get } from 'lodash';

import { INVENTORY_TYPES } from './constants';

export const isPackageInventory = inventory => get(inventory, 'type') === INVENTORY_TYPES.PACKAGE.key;
export const isReceivePackageInventory = inventory => get(inventory, 'type') === INVENTORY_TYPES.RECEIVED.key;
